import { useQuery } from '@tanstack/react-query'

import {
  getEventSchedule,
  getMainContents,
  getOngoingEvent,
} from '~/features/home/apis/mainInfo'

export const useOngoingEvent = () => {
  return useQuery({
    queryKey: ['ongoingEvent'],
    queryFn: () => getOngoingEvent(),
  })
}

export const useEventSchedule = () => {
  return useQuery({
    queryKey: ['eventSchedule'],
    queryFn: () => getEventSchedule(),
  })
}

export const useMainContents = () => {
  return useQuery({
    queryKey: ['main'],
    queryFn: () => getMainContents(),
  })
}
